import { withStyles, WithStyles } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { courseStyles } from "../../styles";
import { BasicInfoType } from "../../types/enums/BasicInfoType";
import StandardCourseBasicInfo from "./StandardCourseBasicInfo";
import ComboCourseBasicInfo from "./ComboCourseBasicInfo";


interface Props extends WithStyles<typeof courseStyles> {
    basicInfoType: string;
    match:any;
    showMenuIcon:boolean;
    coursePlanResponse?:any;
    finalResponse?:any;
    basicInfo: any;
    editMode: boolean;
    goalList?:any
}

interface State {}
class BasicInfo extends Component<Props, State> {


  renderBasicInfo = (basicInfoType: string) => {
    const { editMode } = this.props;
    
      switch(basicInfoType){
          case BasicInfoType.standard:
              return <StandardCourseBasicInfo
              showMenuIcon={this.props.showMenuIcon}
              coursePlanResponse={this.props.coursePlanResponse}
              finalResponse={this.props.finalResponse}
               basicInfo={this.props.basicInfo}
               editMode={editMode}
              />
          case BasicInfoType.testSeries:
            return <>
            {/* Dhanu you can add component here */}
            </>
          case BasicInfoType.comboCourse:
              return <ComboCourseBasicInfo match={this.props.match}
               basicInfo = {this.props.basicInfo}
               showMenuIcon={this.props.showMenuIcon}
               finalResponse={this.props.finalResponse}
               />
          default:
              return <StandardCourseBasicInfo 
              editMode={editMode}
              // basicInfo = {this.props.basicInfo}
               />
      }
  }
 
  render() {
        return <>{this.renderBasicInfo(this.props.basicInfoType)}</>
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(courseStyles)(BasicInfo));
